import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundPattern = _resolveComponent("BackgroundPattern")!
  const _component_HeroBackgroundCommon = _resolveComponent("HeroBackgroundCommon")!
  const _component_HeroBackgroundHeat = _resolveComponent("HeroBackgroundHeat")!
  const _component_HeroBackgroundEmobil = _resolveComponent("HeroBackgroundEmobil")!
  const _component_HeroBackgroundPhoto = _resolveComponent("HeroBackgroundPhoto")!
  const _component_HeroBackgroundBuilding = _resolveComponent("HeroBackgroundBuilding")!
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hero", `hero__${_ctx.pageType}`])
  }, [
    _createVNode(_component_BackgroundPattern),
    (_ctx.pageType === 'common')
      ? (_openBlock(), _createBlock(_component_HeroBackgroundCommon, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.pageType === 'heat')
      ? (_openBlock(), _createBlock(_component_HeroBackgroundHeat, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.pageType === 'emobil')
      ? (_openBlock(), _createBlock(_component_HeroBackgroundEmobil, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.pageType === 'photo')
      ? (_openBlock(), _createBlock(_component_HeroBackgroundPhoto, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.pageType === 'building')
      ? (_openBlock(), _createBlock(_component_HeroBackgroundBuilding, { key: 4 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "hero__container",
      style: _normalizeStyle(_ctx.minHeightPx)
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.pageType !== 'other')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "hero__slogan",
              innerHTML: _ctx.sloganSvg
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.pageType === 'other')
          ? (_openBlock(), _createElementBlock("h1", {
              key: 1,
              innerHTML: _ctx.headline
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "hero__hashtag",
          innerHTML: _ctx.hashtagSvg
        }, null, 8, _hoisted_4)
      ])
    ], 4),
    _createVNode(_component_SectionSpacerClouds, {
      ref: "clouds",
      placement: "top",
      class: "mt-0"
    }, null, 512)
  ], 2))
}